export default {
  state: {
    isOpenNav: false
  },
  mutations: {
    CHANGEISOPENNAV (state) {
      console.log(111)
      state.isOpenNav = !state.isOpenNav
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/mainNav.js